<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content class="lau-AttributesDialog">
  <div class="attributes-list">
    <form [formGroup]="attributesFormGroup">
      <div formArrayName="attributes" *ngFor="let attribute of getControls(); let i = index">
        <mat-checkbox class="example-margin" (change)="onChange($event, attributes[i])" [formControlName]="i">{{
          attributes[i].attributeName
        }}</mat-checkbox>
      </div>
    </form>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="cancelAction()">
    {{ rejectButtonText }}
  </button>
  <button [disabled]="!attributesFormGroup.value.attributes.length" mat-flat-button (click)="confirmAction()">
    {{ confirmButtonText }}
  </button>
</div>
